{
  "tuned_suspension": { "name": "Tuned suspension", "desc": "+15% grip, +10% steering",          "grip": 1.15, "turn": 1.10, "accel": 1,    "hp": 1,   "speed": 1,    "price": 350 },
  "armor_plating":    { "name": "Armor plating",    "desc": "+30% durability",                    "grip": 1,    "turn": 1,    "accel": 1,    "hp": 1.3, "speed": 1,    "price": 450 },
  "turbo_kit":        { "name": "Turbo kit",        "desc": "+15% acceleration, +5% top speed",   "grip": 1,    "turn": 1,    "accel": 1.15, "hp": 1,   "speed": 1.05, "price": 500 }
}
